import React, {useContext, useEffect, useState} from 'react';

import './style.css';
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import {update} from "@api/benefits";
import {LoadingContext} from "@hoc/loading";
import {MessageContext} from "@hoc/messageNotification";
import {getById} from "@api/benefits";
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import RemoveIcon from '@mui/icons-material/Remove';

export const AddDescription = ({data, handleClose}) => {
    const {id} = data;
    const {setLoading} = useContext(LoadingContext);
    const {setErrorMessage} = useContext(MessageContext);
    const [benefit, setBenefit] = useState({description: []});

    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            setLoading(true);
            setErrorMessage(null);
            delete benefit.name;

            await update(benefit.id, {description: [...benefit.description]});
            handleClose(event, data);
        } catch (e) {
            setErrorMessage(e);
        }
        setLoading(false);
    }

    const onChangeDescription = (e, index) => {
        e.preventDefault();

        // const index = e.currentTarget.name;
        const value = e.currentTarget.value;

        benefit.description[index] = value;
        setBenefit({...benefit});
    }

    const onAddDescription = (e) => {
        e.preventDefault();
        setBenefit({...benefit, description: [...benefit.description, []]});
    }
    const onDeleteDescription = (e, index) => {
        e.preventDefault();

        benefit.description.splice(index, 1);
        setBenefit({...benefit});
    }

    useEffect(() => {
        const loadBenefit = async () => {
            const data = await getById(id);
            setBenefit(data);
        }

        loadBenefit();
    }, [id])

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                mt: 1
            }}
            component="form"
            onSubmit={handleSubmit}
            noValidate
        >
            {benefit.description.map((data, ind) => (
                <Box display={"flex"} alignItems={"center"} flexDirection={"row"}>
                    <TextField
                        key={ind}
                        margin="normal"
                        required
                        fullWidth
                        id="description"
                        label="description"
                        name={'name_' + ind}
                        value={data}
                        onChange={(e) => onChangeDescription(e, ind)}
                    />
                    <Button><RemoveIcon onClick={(e) => onDeleteDescription(e, ind)}/></Button>
                </Box>
            ))}
            <Box display={"flex"} justifyContent={"center"}>
                <Button><ControlPointIcon onClick={(e) => onAddDescription(e)}/></Button>
            </Box>
            <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{mt: 3, mb: 2}}
            >
                Add
            </Button>
        </Box>
    )
}
